export const COUNTRY_ACTIONS = {
    COUNTRY_BONDS: 'COUNTRY_BONDS',
    COUNTRY_BONDS_REQUEST: 'COUNTRY_BONDS_REQUEST',
    COUNTRY_BONDS_ERROR: 'COUNTRY_BONDS_ERROR'
};
export const CURRENCY_ACTIONS = {
    CURRENCY_BONDS: 'CURRENCY_BONDS',
    CURRENCY_BONDS_REQUEST: 'CURRENCY_BONDS_REQUEST',
    CURRENCY_BONDS_ERROR: 'CURRENCY_BONDS_ERROR'
};
export const SECTOR_ACTIONS = {
    SECTOR_BONDS: 'SECTOR_BONDS',
    SECTOR_BONDS_REQUEST: 'SECTOR_BONDS_REQUEST',
    SECTOR_BONDS_ERROR: 'SECTOR_BONDS_ERROR'
};
export const INDUSTRY_ACTIONS = {
    INDUSTRY_BONDS: 'INDUSTRY_BONDS',
    INDUSTRY_BONDS_REQUEST: 'INDUSTRY_BONDS_REQUEST',
    INDUSTRY_BONDS_ERROR: 'INDUSTRY_BONDS_ERROR'
};
export const REGION_ACTIONS = {
    REGION_BONDS: 'REGION_BONDS',
    REGION_BONDS_REQUEST: 'REGION_BONDS_REQUEST',
    REGION_BONDS_ERROR: 'REGION_BONDS_ERROR'
};
export const MATURITY_YEAR_ACTIONS = {
    MATURITY_YEAR_BONDS: 'MATURITY_YEAR_BONDS',
    MATURITY_YEAR_BONDS_REQUEST: 'MATURITY_YEAR_BONDS_REQUEST',
    MATURITY_YEAR_BONDS_ERROR: 'MATURITY_YEAR_BONDS_ERROR'
};
export const ISSUE_TYPE_ACTIONS = {
    ISSUE_TYPE_BONDS: 'ISSUE_TYPE_BONDS',
    ISSUE_TYPE_BONDS_REQUEST: 'ISSUE_TYPE_BONDS_REQUEST',
    ISSUE_TYPE_BONDS_ERROR: 'ISSUE_TYPE_BONDS_ERROR'
};
export const GET_TRENDING_BONDS_ACTIONS = {
    GET_TRENDING_BONDS: 'GET_TRENDING_BONDS',
    GET_TRENDING_BONDS_REQUEST: 'GET_TRENDING_BONDS_REQUEST',
    GET_TRENDING_BONDS_ERROR: 'GET_TRENDING_BONDS_ERROR'
};
export const SEND_FEEDBACK_ACTIONS = {
    SEND_FEEDBACK_RESPONSE: 'SEND_FEEDBACK_RESPONSE',
    SEND_FEEDBACK_REQUEST: 'SEND_FEEDBACK_REQUEST',
    SEND_FEEDBACK_ERROR: 'SEND_FEEDBACK__ERROR'
};
export const SUPPORT_FORM_ACTIONS = {
    SUPPORT_FORM_RESPONSE: 'SUPPORT_FORM_RESPONSE',
    SUPPORT_FORM_REQUEST: 'SUPPORT_FORM_REQUEST',
    SUPPORT_FORM_ERROR: 'SUPPORT_FORM_ERROR'
};
export const DATA_UPLOAD_STATUS_ACTIONS = {
    DATA_UPLOAD_STATUS_RESPONSE: 'DATA_UPLOAD_STATUS_RESPONSE',
    DATA_UPLOAD_STATUS_REQUEST: 'DATA_UPLOAD_STATUS_REQUEST',
    DATA_UPLOAD_STATUS_ERROR: 'DATA_UPLOAD_STATUS_ERROR'
};
export const GET_ADSKEY_EXISTS_ACTIONS = {
    GET_ADSKEY_EXISTS_REQUEST: ' GET_ADSKEY_EXISTS_REQUEST',
    GET_ADSKEY_EXISTS_RESPONSE: ' GET_ADSKEY_EXISTS_RESPONSE',
    GET_ADSKEY_EXISTS_ERROR: 'GET_ADSKEY_EXISTS_ERROR'
};
export const CREATE_ADSKEY_EXISTS_ACTIONS = {
     CREATE_EXISTS_REQUEST: '  CREATE_EXISTS_REQUEST',
     CREATE_EXISTS_RESPONSE: '  CREATE_EXISTS_RESPONSE',
     CREATE_EXISTS_ERROR: ' CREATE_EXISTS_ERROR'
};